import React from 'react';
import HelpCenter from '../Components/InfoPages/HelpCenter';

function HelpPage() {
  return <HelpCenter />;
}

export default HelpPage;
